const pinkA = {
  pinkA1: "hsla(320, 100%, 51.0%, 0.012)",
  pinkA2: "hsla(323, 100%, 51.0%, 0.032)",
  pinkA3: "hsla(323, 98.9%, 47.3%, 0.067)",
  pinkA4: "hsla(323, 99.9%, 44.3%, 0.102)",
  pinkA5: "hsla(324, 99.9%, 42.3%, 0.153)",
  pinkA6: "hsla(323, 99.5%, 39.6%, 0.224)",
  pinkA7: "hsla(323, 99.7%, 38.5%, 0.322)",
  pinkA8: "hsla(323, 99.5%, 37.7%, 0.444)",
  pinkA9: "hsla(322, 99.7%, 39.3%, 0.750)",
  pinkA10: "hsla(322, 100%, 39.1%, 0.808)",
  pinkA11: "hsla(322, 99.8%, 39.0%, 0.887)",
  pinkA12: "hsla(321, 99.8%, 10.0%, 0.961)"
};
export { pinkA };
//# sourceMappingURL=pinkA.mjs.map
